import { createAction } from '@src/components/redux-act';

export const setBasePageBack = createAction("base页返回确认弹框");
export const setInEditPage = createAction('判断是否在基本信息编辑页');
export const setHasNewVersion = createAction('判断是否有新版本');
